import React, { useState } from 'react';
import { AppBar, Toolbar, Button, Box, Menu, MenuItem, Grid2 } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const PublicHeader = () => {
    const navigate = useNavigate();

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleMenuClick = (path) => {
        handleMenuClose();
        navigate(path);
    };

    return (
        <AppBar
            position="fixed"
            sx={{
                zIndex: 1201,
                backgroundColor: '#34495e',
                color: '#ecf0f1',
            }}
        >
            <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                {/* Clickable Logo */}
                <Box
                    onClick={() => navigate('/')}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer',
                    }}
                >
                    <img
                        src="/instapath-logo.png"
                        alt="Instapath Logo"
                        style={{
                            width: '144px',
                        }}
                    />
                </Box>

                {/* Right-Aligned Buttons */}
                <Box sx={{ display: 'flex', gap: 2 }}>
                    {/* Dropdown Menu */}
                    <Box>
                        <Button
                            onClick={handleMenuOpen}
                            sx={{
                                color: '#ecf0f1',
                                fontWeight: 400,
                                textTransform: 'none',
                                '&:hover': { backgroundColor: '#2c3e50' },
                            }}
                        >
                            Solutions
                        </Button>
                        <Menu
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleMenuClose}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            slotProps={{
                                paper: {
                                    sx: {
                                        width: 'auto',
                                        maxWidth: '900px',
                                        backgroundColor: '#ffffff',
                                        color: '#2c3e50',
                                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                                        marginTop: '8px',
                                        padding: '16px 24px',
                                    },
                                },
                            }}
                        >
                            <Grid2 container spacing={2} alignItems="flex-start">
                                {/* Column 1: Instapath Cloud */}
                                <Grid2
                                    xs="auto"
                                    sx={{
                                        maxWidth: '280px',
                                        padding: '8px',
                                        paddingLeft: '16px',
                                        paddingRight: '16px',
                                        borderRight: '1px solid #ddd',
                                        textAlign: 'left',
                                    }}
                                >
                                    <Box
                                        sx={{
                                            fontSize: '16px',
                                            fontWeight: 600,
                                            marginBottom: '8px',
                                            color: '#2c3e50',
                                            //fontFamily: 'Roboto, sans-serif',
                                        }}
                                    >
                                        Platform
                                    </Box>
                                    <Box
                                        sx={{
                                            cursor: 'pointer',
                                            '&:hover': { backgroundColor: '#f0f0f0' },
                                        }}
                                        onClick={() => handleMenuClick('/')}
                                    >
                                        <Box
                                            sx={{
                                                fontSize: '16px',
                                                fontWeight: '500',
                                                color: '#555',
                                                fontFamily: 'Poppins, sans-serif',
                                            }}
                                        >
                                            Instapath
                                        </Box>
                                        <Box
                                            sx={{
                                                fontSize: '14px',
                                                fontWeight: '400',
                                                color: '#555',
                                                fontFamily: 'Poppins, sans-serif',
                                            }}
                                        >
                                            The end-to-end solution for drone operations management.
                                        </Box>
                                    </Box>
                                </Grid2>

                                {/* Column 2: Mobile */}
                                <Grid2
                                    xs="auto"
                                    sx={{
                                        maxWidth: '280px',
                                        padding: '8px',
                                        paddingLeft: '16px',
                                        paddingRight: '32px',
                                        borderRight: '1px solid #ddd',
                                        textAlign: 'left',
                                    }}
                                >
                                    <Box
                                        sx={{
                                            fontSize: '16px',
                                            fontWeight: 600,
                                            marginBottom: '8px',
                                        }}
                                    >
                                        Mobile
                                    </Box>
                                    <MenuItem
                                        onClick={() => handleMenuClick('/platform/mobile')}
                                        sx={{
                                            fontSize: '16px',
                                            fontWeight: '500',
                                            color: '#555',
                                            fontFamily: 'Poppins, sans-serif',
                                            paddingLeft: '0',
                                            paddingRight: '0',
                                            '&:hover': { backgroundColor: '#f0f0f0' },
                                        }}
                                    >
                                        Instapath Pilot
                                    </MenuItem>
                                </Grid2>

                                {/* Column 3: Training */}
                                <Grid2
                                    xs="auto"
                                    sx={{
                                        maxWidth: '280px',
                                        padding: '8px',
                                        paddingLeft: '16px',
                                        paddingRight: '16px',
                                        textAlign: 'left',
                                    }}
                                >
                                    <Box
                                        sx={{
                                            fontSize: '16px',
                                            fontWeight: 600,
                                            marginBottom: '8px',
                                        }}
                                    >
                                        Training
                                    </Box>
                                    <MenuItem
                                        onClick={() => handleMenuClick('/platform/pilots-ed')}
                                        sx={{
                                            fontSize: '16px',
                                            fontWeight: '500',
                                            color: '#555',
                                            fontFamily: 'Poppins, sans-serif',
                                            paddingLeft: '0',
                                            paddingRight: '0',
                                            '&:hover': { backgroundColor: '#f0f0f0' },
                                        }}
                                    >
                                        107 Pilot School
                                    </MenuItem>
                                </Grid2>
                            </Grid2>
                        </Menu>
                    </Box>

                    <Button
                        onClick={() => navigate('/pricing')}
                        sx={{
                            color: '#ecf0f1',
                            fontWeight: 400,
                            textTransform: 'none',
                            '&:hover': { backgroundColor: '#2c3e50' },
                        }}
                    >
                        Pricing
                    </Button>
                    <Button
                        onClick={() => navigate('/blog')}
                        sx={{
                            color: '#ecf0f1',
                            fontWeight: 400,
                            textTransform: 'none',
                            '&:hover': { backgroundColor: '#2c3e50' },
                        }}
                    >
                        Blog
                    </Button>
                    <Button
                        onClick={() => navigate('/contact')}
                        sx={{
                            color: '#ecf0f1',
                            fontWeight: 400,
                            textTransform: 'none',
                            '&:hover': { backgroundColor: '#2c3e50' },
                        }}
                    >
                        Contact
                    </Button>
                    <Button
                        onClick={() => navigate('/authmgr')}
                        sx={{
                            color: '#ecf0f1',
                            fontWeight: 400,
                            textTransform: 'none',
                            border: '1px solid #ecf0f1', // Add a border
                            borderRadius: '8px', // Rounded corners
                            padding: '6px 16px', // Add padding for a balanced look
                            '&:hover': {
                                backgroundColor: '#2c3e50',
                                borderColor: '#95a5a6', // Change border color on hover
                            },
                        }}
                    >
                        Log In
                    </Button>
                </Box>
            </Toolbar>
        </AppBar>
    );
};

export default PublicHeader;